module.exports = __webpack_public_path__ + "static/media/blackHeartIcon.fed97292.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackHeartIcon.svg
// module id = 98
// module chunks = 0